import { useQuery } from '@tanstack/react-query';
import { getOutreachClient } from '@/lib/api-clients';
import { queryKeys } from '@/lib/query-keys';
import { CACHE_TIME_10_MINS } from '@/lib/query-client';

/**
 * A campaign's results (ADR-318, F/H): counts only, computed on read from the
 * runs that started in the range. Ten-minute staleness: results move as calls
 * finish, not as the page is looked at.
 */
export function useCampaignResults(
  id: string | undefined,
  /** Null: the practice's last 30 days, in its own timezone (the list's figure). */
  range: { from: string; to: string } | null,
  opts?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: queryKeys.outreach.results(id ?? '', range?.from ?? 'default', range?.to ?? ''),
    queryFn: () => getOutreachClient().results(id!, range ?? {}),
    enabled: (opts?.enabled ?? true) && !!id,
    staleTime: CACHE_TIME_10_MINS,
  });
}
